import { Box, CircularProgress } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import ActionButton from "../../_include/Buttons/ActionButton";
import { AwarenessCampaignStatus } from "../../../models/AwarenessCampaign";
import { Namespace } from "../../../locales/translations";
import { useTranslation } from "react-i18next";
import { SelectedAwarenessCampaignActions } from "../../../store/reducers/awareness_campaigns/selected";
import { useAmbassadorMissionCompleted } from "../../../hooks/awarenessCampaigns";

export default function AwarenessCampaignActions() {

    const { t } = useTranslation([Namespace.ACTIONS]);

    const isLoading = useAppSelector(state => state.awareness_campaign.selected.loading);

    const isCompleted = useAmbassadorMissionCompleted();

    const dispatch = useAppDispatch();

    const handleMarkCompletedClick = () => {
        dispatch(SelectedAwarenessCampaignActions.setConfirmCompleteDialogOpen(true));
    }

    return (
        <Box mt={3} display="flex" justifyContent="center" alignItems="center">
            {isLoading ? (
                <CircularProgress size={24} sx={{ mr: 2 }} />
            ) : null}
            <ActionButton
                onClick={handleMarkCompletedClick}
                disabled={isCompleted}
                loading={isLoading}
            >
                {t('mark_as_completed', { ns: Namespace.ACTIONS })}
            </ActionButton>
        </Box>
    )
}